import Image from "next/image";
import connectPlus from "../public/connect-plus.png";
import pearlyPlan from "../public/pearly-plan.png";
import dsoCompliance from "../public/dso-compliance.png";
import inventorySystem from "../public/inventory-system.png";
import interphase from "../public/interphase.png";
import learnosity from "../public/learnosity.png";
import rfp from "../public/rfp.png";
import aps from "../public/aps.png";
import Link from "next/link";
import { environmentVariables } from "./ReadContent";

const ProjectCard = () => {
  const imageMap = {
    connectPlus: connectPlus,
    pearlyPlan: pearlyPlan,
    dsoCompliance: dsoCompliance,
    inventorySystem: inventorySystem,
    interphase: interphase,
    rfp: rfp,
    aps: aps,
    learnosity: learnosity,
  };

  const data = environmentVariables.getWorkData;

  return (
    <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3">
      {data.map((project) => {
        return (
          <div
            className="rounded-lg mb-12 flex flex-col items-center"
            key={project.id}
          >
            {project.link === "" ? (
              <Image
                loading="lazy"
                src={imageMap[project.image]}
                alt={project.title}
                width="200"
                className="rounded-md drop-shadow-2xl hover:scale-110"
              />
            ) : (
              <Link
                href={project.link}
                target="_self"
                onClick={() => {
                  project.link === ""
                    ? alert("You are already on this site! 🤩")
                    : "";
                }}
              >
                <Image
                  loading="lazy"
                  src={imageMap[project.image]}
                  alt={project.title}
                  width="200"
                  className="rounded-md drop-shadow-2xl hover:scale-110"
                />
              </Link>
            )}
            <div className="flex flex-col items-center">
              <h1 className="font-semibold text-[1.5rem] mt-3 text-gray-700 dark:text-white">
                {project.title}
              </h1>
              <p className="max-w-[90%] text-gray-400 font-light text-center">
                {project.description}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ProjectCard;
